import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { SectionHead } from '../components/ui';
import { C } from '../styles';

interface Props {
  title: string;
}

export default function ReviewSection({ title }: Props) {
  return (
    <>
      <SectionHead title={title} subtitle="This section is being built and will be available soon." />
      <div style={{
        background: '#fff', border: '1px solid ' + C.line,
        borderRadius: 10, padding: '48px 40px', textAlign: 'center',
      }}>
        <div style={{
          width: 56, height: 56, borderRadius: '50%',
          background: C.tealSoft, color: C.tealInk,
          display: 'grid', placeItems: 'center', margin: '0 auto 18px',
        }}>
          <AlertTriangle size={24} />
        </div>
        <div style={{ fontSize: 18, fontWeight: 600, color: C.ink, marginBottom: 8 }}>Coming soon</div>
        <div style={{ fontSize: 13, color: C.muted, maxWidth: 400, margin: '0 auto', lineHeight: 1.6 }}>
          We are building this section now. The other Payroll Settings sections are fully functional and you can configure them in the meantime.
        </div>
      </div>
    </>
  );
}